module.exports = __webpack_public_path__ + "static/media/monitoring3.9b4b6701.png";